import React from "react";
import PropTypes from "prop-types";

import { Button, Popup } from "semantic-ui-react";

import useSendEmailToService from "./hook/useSendEmailToService";

function SendEmail({ to, subject, body }) {
  const sendEmailToService = useSendEmailToService();

  return (
    <Popup
      flowing
      on="click"
      position="bottom center"
      style={{ padding: "0" }}
      trigger={
        <Button primary floated="right">
          Send Email
        </Button>
      }
    >
      <Button.Group basic vertical>
        <Button
          content="Gmail"
          href={sendEmailToService(to, subject, body, "gmail")}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textAlign: "left", paddingLeft: "0.5em", width: "10em" }}
        />
        <Button
          content="Outlook.com"
          href={sendEmailToService(to, subject, body, "outlook")}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textAlign: "left", paddingLeft: "0.5em", width: "10em" }}
        />
        <Button
          content="Yahoo"
          href={sendEmailToService(to, subject, body, "yahoo")}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textAlign: "left", paddingLeft: "0.5em", width: "10em" }}
        />
        <Button
          content="Local Client"
          href={sendEmailToService(to, subject, body, "local")}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textAlign: "left", paddingLeft: "0.5em", width: "10em" }}
        />
      </Button.Group>
    </Popup>
  );
}

SendEmail.propTypes = {
  to: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
};

export default SendEmail;
